import { render, staticRenderFns } from "./PixelIcon.vue?vue&type=template&id=0302e448"
import script from "./PixelIcon.vue?vue&type=script&lang=js"
export * from "./PixelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0302e448')) {
      api.createRecord('0302e448', component.options)
    } else {
      api.reload('0302e448', component.options)
    }
    module.hot.accept("./PixelIcon.vue?vue&type=template&id=0302e448", function () {
      api.rerender('0302e448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/PixelIcon.vue"
export default component.exports